module.exports = __webpack_public_path__ + "static/white-band-ff460aaf70c9e9b4352a9cc6a74bf86a.png";